import React from 'react';
import PropTypes from 'prop-types';

import legacyTracker from '@finn-no/analytics';
import pulseTracker from '@finn-no/pulse-sdk';

function Button({
    url,
    disabled,
    onClick,
    unknownDisableReason,
    buttonVariant,
}) {
    return disabled ? (
        <button
            type="button"
            title={
                unknownDisableReason
                    ? 'En feil har oppstått'
                    : 'Du kan nok ikke sende melding til deg selv'
            }
            className="button button--cta u-size1of1"
            disabled
        >
            Send melding
        </button>
    ) : (
        <a
            rel="nofollow"
            href={url}
            className={
                buttonVariant === 'SECONDARY'
                    ? 'button u-size1of1'
                    : 'button button--cta u-size1of1'
            }
            onClick={onClick}
        >
            Send melding
        </a>
    );
}

Button.propTypes = {
    url: PropTypes.string.isRequired,
    disabled: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired,
    unknownDisableReason: PropTypes.bool.isRequired,
    buttonVariant: PropTypes.string.isRequired,
};

export default function ButtonWithTracking({
    url,
    disabled,
    unknownDisableReason,
    adId,
    buttonVariant,
}) {
    function trackButtonClick() {
        pulseTracker.trackEvent({
            type: 'Click',
            intent: 'Create',
            name: 'Send message',
            object: {
                id: 'sendMessageButton',
                type: 'UIElement',
                elementType: 'Button',
                items: [
                    {
                        type: 'ClassifiedAd',
                        id: adId,
                        contentId: adId,
                        name: 'n/a',
                        category: 'n/a',
                        hasExtendedProfile: 'false',
                    },
                ],
                page: {
                    type: 'ClassifiedAd',
                },
            },
            target: {
                id: 'id',
                type: 'Message',
            },
        });

        legacyTracker.trackEventLater({
            analyticsName: 'contact.send-message.click',
            eventFlags: 'start',
            kpi: 'effect',
            ecType: 'USER',
            ecCategory: 'contact.send-message.click',
            pulse: {
                type: 'Engagement',
                action: 'Click',
                object: {
                    type: 'UIElement',
                    id: 'send-melding',
                    name: 'Send melding',
                },
                target: {
                    type: 'ClassifiedAd',
                },
            },
        });
    }
    return (
        <Button
            url={url}
            disabled={disabled}
            onClick={trackButtonClick}
            unknownDisableReason={unknownDisableReason}
            buttonVariant={buttonVariant}
        />
    );
}

ButtonWithTracking.defaultProps = {
    disabled: false,
    url: '',
    unknownDisableReason: false,
    adId: null,
    buttonVariant: 'PRIMARY',
};

ButtonWithTracking.propTypes = {
    disabled: PropTypes.bool,
    url: PropTypes.string,
    unknownDisableReason: PropTypes.bool,
    adId: PropTypes.number,
    buttonVariant: PropTypes.string,
};
